import angular from 'angular';
import moment from 'moment';
import ngMessages from 'angular-messages';
import TkrSpaCommon from '../../../common/tkr-spa';
import { TkrPersonService } from '../../../common/tkr-commonservices';
import { IbanService, IbanValidator } from '../../../common/ma-iban';
import { SmartFloat, SmartInteger } from '../../../common/ma-smartfloat-1.0';
import TkrPpCommon from '../../../pp/common/0-pp-common-module';
import TkrPpResources from '../../../pp/prcportal-resource-modules';
import MaDatepicker from '../../../common/ma-datepicker-uib';
import { configureTranslateProvider } from '../../../pp/translation-helpers';
import ngTranslate from 'angular-translate';
import 'angular-translate-loader-static-files';
const subsidy_application_app = angular.module('ng-tkr-app-pieksamaki', [
    TkrSpaCommon,
    ngMessages,
    ngTranslate,
    TkrPersonService,
    IbanValidator,
    IbanService,
    SmartFloat,
    SmartInteger,
    MaDatepicker,
    TkrPpResources,
    TkrPpCommon,
])
    .config(config)
    .config(configureTranslateProvider);
export default subsidy_application_app.name;
config.$inject = ['$stateProvider', '$urlRouterProvider'];
function config($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/err');
    $stateProvider
        .state('err', {
        url: '/err',
        template: '<p class="h4 text-danger">Sisäinen virhe. Ota yhteyttä helpdesk@matriset.fi.</p>'
    })
        .state('root', {
        url: '',
        template: '',
        controller: 'AppRedirCtrl',
        controllerAs: 'vm'
    })
        .state('lomake', {
        url: '/:applicationId',
        template: require('./app.tpl.html'),
        controller: 'SubsidyApplicationController',
        controllerAs: 'vm',
        resolve: {
            app: ['PortalSubsidyAppService', '$stateParams', function (PortalSubsidyAppService, $stateParams) {
                    return PortalSubsidyAppService.get({ appId: $stateParams.applicationId }).$promise;
                }],
            appPeriod: ['PortalAppPeriodService', 'app', function (PortalAppPeriodService, app) {
                    return PortalAppPeriodService.get({ periodId: app.applicationPeriodId }).$promise;
                }]
        }
    })
        .state('jatetty', {
        url: '/:applicationId/jatetty',
        template: require('./app-submitted.tpl.html'),
        controller: 'AppSubmittedController',
        controllerAs: 'vm'
    });
}
subsidy_application_app.controller('SubsidyApplicationController', SubsidyApplicationController);
SubsidyApplicationController.$inject = [
    '$scope',
    'app',
    'appPeriod',
    'TkrPersonService',
    '$state',
];
function SubsidyApplicationController($scope, app, appPeriod, TkrPersonService, $state) {
    var vm = this;
    vm.vuosi = appPeriod.td.wnum.vuosi;
    vm.edvuosi = vm.vuosi - 1;
    vm.loppuAika = moment(appPeriod.end).local().format('D.M.YYYY HH:mm');
    vm.personRoles = TkrPersonService.personRoles;
    vm.chairmanRoles = TkrPersonService.chairmanRoles;
    vm.preprocessApp = function (app) {
        if (!app.chairman) {
            app.chairman = {};
        }
        if (!app.chairman.td) {
            app.chairman.td = {};
        }
        if (!app.chairman.td.bools) {
            app.chairman.td.bools = {};
        }
        if (!app.contactPerson) {
            app.contactPerson = {};
        }
        if (!app.contactPerson.td) {
            app.contactPerson.td = {};
        }
        if (!app.contactPerson.td.bools) {
            app.contactPerson.td.bools = {};
        }
        if (!app.td) {
            app.td = {};
        }
        if (!app.td.bools) {
            app.td.bools = {};
        }
        if (!app.td.dates) {
            app.td.dates = {};
        }
        if (!app.td.num) {
            app.td.num = {};
        }
        if (app.td.bools.elakelaistentie) {
            $scope.tietyyppi = 'elakelaistentie';
        }
        else if (app.established) {
            $scope.tietyyppi = 'jarjestaytynyt';
        }
        else {
            $scope.tietyyppi = 'tilustie';
        }
        if (!app.addressNames) {
            app.addressNames = [];
        }
    };
    vm.postprocessApp = function (app) {
        if (!vm.isSeparateChairmanRequired()) {
            if (vm.isChairmanRequired()) {
                app.chairman = app.contactPerson;
            }
            else {
                app.chairman = null;
            }
        }
        if (!app.established) {
            app.td.dates.perustettu = null;
            app.contactPerson.role = undefined;
            app.td.bools.mmldigiroad = false;
            app.totalLength = undefined;
            app.bypassRoad = false;
            app.td.num.hallintoMenotEdvuosi = 0;
        }
    };
    vm.preprocessApp(app);
    vm.app = app;
    $scope.$watch('tietyyppi', function (newValue, oldValue) {
        if (newValue == 'elakelaistentie') {
            vm.app.established = false;
            vm.app.td.bools.elakelaistentie = true;
        }
        else if (newValue == 'jarjestaytynyt') {
            vm.app.established = true;
            vm.app.td.bools.elakelaistentie = false;
        }
        else {
            vm.app.established = false;
            vm.app.td.bools.elakelaistentie = false;
        }
    });
    vm.isChairmanRequired = function () {
        return $scope.tietyyppi == 'jarjestaytynyt';
    };
    vm.isSeparateChairmanRequired = function () {
        return vm.isChairmanRequired() &&
            TkrPersonService.isValidChairmanRole(vm.app.contactPerson.role) == false;
    };
    vm.save = function () {
        vm.postprocessApp(vm.app);
        vm.app.applicationState = 'SUBMITTED';
        vm.app.$save(function (data) {
            $state.go('jatetty', { applicationId: data.id });
        });
    };
    vm.saveDraft = function () {
        vm.app.applicationState = 'DRAFT';
        vm.app.$save(function (data) {
            vm.draftSaved = true;
        });
    };
    vm.attachmentDefsJarj = [
        {
            type: 'tilinpaatos',
            name: 'Tilinpäätös',
            required: false,
        },
        {
            type: 'poytakirja',
            name: 'Edellisen vuosikokouksen pöytäkirjan ote, jossa hoitokunnalle tai toimitsijamiehelle on myönnetty tili-ja vastuuvapaus',
            required: false,
            help: 'Yksityistielain 60 §:n mukaan tiekunnan on pidettävä vuosikokous vuosittain tai vuosikokousta vastaava kokous vähintään joka neljäs vuosi.'
        },
        {
            type: 'digiroad',
            name: 'Digiroad yksityistieilmoituksen tosite',
            required: false,
            help: 'Tekemällä yksityistieilmoituksen Digiroadiin, tiekunta saa itselleen tositteen yksityistietietojen ilmoittamisesta Digiroadiin. Tosite tulee liittää yksityistien avustushakemukseen. Yksityistietietojen ilmoittaminen digiroadiin: <a href="https://vayla.fi/vaylista/aineistot/digiroad/yksityistietietojen-lisaaminen-digiroadiin">https://vayla.fi/vaylista/aineistot/digiroad/yksityistietietojen-lisaaminen-digiroadiin</a>',
        },
    ];
}
subsidy_application_app.directive('pmEdit', EditorDirective);
EditorDirective.$inject = ['$compile'];
function EditorDirective($compile) {
    var buildTemplate = function (scope, attrs) {
        var inputId = 'fld' + scope.$id;
        var inputLabel = attrs.inputLabel || inputId;
        var htmlInputType = 'text';
        var inputExtra = '';
        var addonOpen = '';
        var addonClose = '';
        var mSize = attrs.mSize || '';
        if (attrs.mType == 'integer') {
            inputExtra += 'smart-integer';
        }
        else if (attrs.mType == 'number') {
            inputExtra += 'smart-float';
        }
        else if (attrs.mType == 'email') {
            htmlInputType = 'email';
        }
        if (scope.inputAddon) {
            addonOpen = '<div class="input-group">';
            addonClose = '<span class="input-group-addon">' + scope.inputAddon + '</span></div>';
        }
        var html = [];
        html.push('<div class="form-group" ng-class="{ \'has-error\' : appForm.INPUTID.$invalid }">');
        html.push('<label for="INPUTID" class="control-label col-sm-4 col-md-3">INPUTLABEL <span ng-if="required">*</span></label>');
        html.push('<div class="col-sm-6">');
        html.push(addonOpen);
        html.push('<input type="' + htmlInputType + '" class="form-control M_SIZE" id="INPUTID" name="INPUTID" placeholder="INPUTLABEL" ng-model="ngModel" ' + inputExtra + ' ng-required="required">');
        html.push(addonClose);
        html.push('<div ng-messages="appForm.INPUTID.$error" role="alert">');
        html.push('<p ng-message="required" class="help-block bg-danger">Pakollinen tieto</p>');
        html.push('<p ng-message="integer" class="help-block bg-danger">Syötä kokonaisluku</p>');
        html.push('<p ng-message="float" class="help-block bg-danger">Syötä desimaaliluku</p>');
        html.push('<p ng-message="email" class="help-block bg-danger">Syötä sähköpostiosoite</p>');
        html.push('</div>');
        if (attrs.mHelp) {
            html.push('<p class="help-block">' + attrs.mHelp + '</p>');
        }
        html.push('</div>');
        html.push('</div>');
        var result = html.join("\n").replace(/INPUTID/g, inputId).replace(/INPUTLABEL/g, inputLabel).replace(/M_SIZE/g, mSize);
        return result;
    };
    var linker = function linker(scope, element, attrs, ctrls) {
        scope.appForm = ctrls[0];
        scope.inputAddon = attrs.inputAddon;
        scope.required = attrs.required === '' ? true : attrs.required;
        element.html(buildTemplate(scope, attrs)).show();
        $compile(element.contents())(scope);
    };
    return {
        restrict: 'E',
        replace: false,
        require: ['^form'],
        scope: {
            ngModel: '=',
            mSize: '='
        },
        link: linker
    };
}
